<template>
	<div id="idFrameApp" ref="idFrameApp">
		<div id="idFormLogin" ref="idFormLogin">
			<loginFrm :key="KeyLogin" ref="idLoginFrm"></loginFrm>
		</div>
		<div id="idMainL1"  ref="idMainL1">
			<div id="idMainL2" ref="idMainL2">
				<div id="idFormTop" ref="idFormTop" class="clrBG1" style="flex: 0 0 auto; width:100%; border:0px solid red;">
					<!-- 顶部组件定义 -->
					<topbar id="idTopbar" ref="idTopbar"></topbar>
				</div>
				<div class="clrBG1" style="flex: 0 0 auto; height:5px; border:0px solid #00ffff;" ref="idHSplit1"></div>
				<div style="flex: 1 0 auto; width:100%; border:0px solid black;">
					<div id="idMainL3" ref="idMainL3">
						<div class="clrBG1" style="flex: 0 0 auto; height:100%; width:5px; border:0px solid #00ffff;" ref="idRSplit1"></div>
						<div id="idFormLeft" ref="idFormLeft" style="flex: 0 0 auto; border:0px solid #00ff00;">
							<MainMenu id="idMainMenu" ref="idMainMenu"></MainMenu>
						</div>
						<div style="flex: 0 0 auto; height:100%; width:5px; border:0px solid #00ffff;" class="clrBG1"  ref="idRSplit2"></div>
						<div style="flex:0 0 auto; border:0px solid red; width:12px;" ref="idMenuHidePan">
							<table style="height:100%; width:100%;"><tr><td>
								<div id="idMenuHideArr" ref="idMenuHideArr" class="MenuHideArr1" style="float:left; margin-left:-1px; cursor:pointer; width:11px; height:78px;" @click="onMenuHideClick"></div>
							</td></tr></table>
						</div>
						<div id="idFormOP" ref="idFormOP" style="flex: 1 0 auto; z-index:0; border:0px solid #ffff00;">
							<!-- 右侧主操作区组件定义 -->
							<div style="width:100%; height:100%; display:flex; border:0px solid #0000ff;">
								<router-view></router-view>
							</div>
						</div>
						<div class="clrBG1" style="flex: 0 0 auto; height:100%; width:5px; border:0px solid #00ffff;"  ref="idRSplit3"></div>
					</div>
				</div>
				<div class="clrBG1" style="flex: 0 0 auto; height:5px; border:0px solid #00ffff;" ref="idHSplit2"></div>
			</div>
		</div>

		<div id="idDlgMask" ref="idDlgMask" style="display:none;"></div>
		<div id="idDlgFrm" ref="idDlgFrm" style="position:absolute; z-index:990; width:100%; height:100%; border:0px solid red; display:none;" @click="onDlgClick">
			<!-- 正在执行提示框 -->
			<div id="idDlgRun" ref="idDlgRun" style="display:none;"></div>
			<div id="idDlgTip" ref="idDlgTip" style="display:none;"></div>
			<div id="idDlgCfm" ref="idDlgCfm" style="display:none;">
				<div id="idCfmCapt" ref="idCfmCapt" class="DIVNoSelect" style="width:100%; height:40px; line-height:40px; background:#2a83cf; border-radius:7px 7px 0px 0px; text-indent:10px; color:#ffffff;"></div>
				<div style="float:left; width:100%; border:0px solid blue; margin-top:6px;">
					<div id="idCfmIcon" ref="idCfmIcon" style="float:left; margin-left:30px; width:32px;  height:32px;"></div>
					<div id="idCfmMsg"  ref="idCfmMsg" style="float:left; margin-left:20px; width:300px; height:64px; line-height:32px; border:0px solid red; font-size:18px; letter-spacing:1px; text-overflow: ellipsis; overflow: hidden;"></div>
					<div id="idCfmRemk" ref="idCfmRemk" style="float:left; margin-left:20px; width:360px; height:50px; line-height:16px; border:0px solid red; font-size:14px; text-indent:29px; text-overflow: ellipsis; overflow: hidden; display:-webkit-box; -webkit-line-clamp:3; -webkit-box-orient:vertical; margin-top:10px;"></div>
				</div>
				<div style="width:100%; float:left; border:0px solid red; margin-top:16px;">
					<div class="NButton" id="idCfmOK"  ref="idCfmOK"  style="width:70px; margin-top:-1px; margin-left:100px;" @click="onCfmOKClick">{{getLangText("确定")}}</div>
					<div class="NButton" id="idCfmCan" ref="idCfmCan" style="width:70px; margin-top:-1px; margin-right:100px; float:right;" @click="onCfmCanClick">{{getLangText("取消")}}</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>

import Vue          from 'vue'

/* 根据不同的项目, 引入不同的顶部导航组件、主菜单组件、登录组件 */
import topbar       from './topbar'
import MainMenu     from './mainmenu'
import loginFrm     from './login'

String.prototype.getBytesLength = function(){
	var totalLength = 0;
	var charCode;
	for (var i = 0; i < this.length; i++) {
		charCode = this.charCodeAt(i);
		if (charCode < 0x007f)
			totalLength++
		else
			totalLength += 2;
	}
	return totalLength;
}

/* 引入echarts */
import * as echarts from "echarts"
Vue.prototype.$echarts = echarts

/* 判断值是否数值 */
Vue.prototype.isNumber = function( v ){
	return !isNaN(parseFloat(v)) && isFinite(v);
}
/* 判断是否json对象 */
Vue.prototype.isJSonObject = function( data ){
	if(typeof(data) == "object" &&  Object.prototype.toString.call(data).toLowerCase() == "[object object]" && !data.length)
		 return true;
	else return false;
}

/* 设置输入焦点 */
Vue.prototype.setFocus = function( obj ){
	obj.focus();
}

Vue.prototype.setDisableInput = function( obj ){
	obj.setAttribute("disabled", "true");
	//obj.style["border"] = "1px solid #dddddd";
	obj.style["color"]  = "#bbbbbb";
}

Vue.prototype.isNullAs = function( o, v ){
	if( !v && v!=0 ) v="";
	if( o==null || o==undefined || o=="null" ) return v;  else return o;
}

/* 取日期时间, diff:相较于当前日期的时间差(秒) */
Vue.prototype.getDateInt = function(diff){
	let dt=new Date();

	if( diff != null ) dt.setTime(dt.getTime() + (diff*1000));
	let y    = dt.getFullYear();
	let m    = dt.getMonth()+1;
	let d    = dt.getDate();

	return ((y*100+m)*100+d);
}

/* 取唯一ID */
Vue.prototype.getUIID = function(){
	let dt=new Date();

	let y    = dt.getFullYear();
	let m    = dt.getMonth()+1;
	let d    = dt.getDate();
	let H    = dt.getHours();
	let M    = dt.getMinutes();
	let S    = dt.getSeconds();
	let ms   = dt.getMilliseconds();

	let i1=(y*100+m)*100+d;
	let i2=((100+H)*100+M)*100+S;
	let i3=1000+ms;

	return i1+""+(i2+"").substring(1, 7)+""+(i3+"").substring(1, 4);
}

Vue.prototype.daysDiff = function( date1, date2 ){
  // 获取两个日期的时间戳
  let ts1 = (new Date(date1)).getTime();
  let ts2 = (new Date(date2)).getTime();

  // 计算差异的毫秒数
  let difference = ts1 - ts2;

  // 将毫秒数转换为天数
  let days = Math.floor(difference / (1000 * 60 * 60 * 24));

  return days;
}

Vue.prototype.setTextByLan = function(){
	let eles=document.getElementsByTagName( "*" );
	for(let i=0; i<eles.length; i++ )
	{
		let v1=eles[i].getAttribute("cpla");
		if( v1 && v1 != "" ) eles[i].setAttribute("placeholder", LangText(v1) );

		let v2=eles[i].getAttribute("ctxt");
		if( v2 && v2 != "" ) eles[i].innerText = LangText(v2);

		let v3=eles[i].getAttribute("ctit");
		if( v3 && v3 != "" ) eles[i].setAttribute("title", LangText(v3) );
	}
}

/* 取日期时间, diff:相较于当前日期的时间差(秒) */
Vue.prototype.getDTStr = function(dFlag, tFlag, wFlag, diff){
	let dt=new Date();

	if( diff != null ) dt.setTime(dt.getTime() + (diff*1000));

	let y    = dt.getFullYear();
	let m    = dt.getMonth()+1;
	let d    = dt.getDate();
	let H    = dt.getHours();
	let M    = dt.getMinutes();
	let S    = dt.getSeconds();
	let days = dt.getDay();

	if(m <=9 ) { m = '0'+m; }
	if(d <=9 ) { d = '0'+d; }
	if(H <=9 ) { H = '0'+H; }
	if(M <=9 ) { M = '0'+M; }
	if(S <=9 ) { S = '0'+S; }

	switch(days){
		case 1:  days='星期一';  break;
		case 2:  days='星期二';  break;
		case 3:  days='星期三';  break;
		case 4:  days='星期四';  break;
		case 5:  days='星期五';  break;
		case 6:  days='星期六';  break;
		case 0:  days='星期日';  break;
	}

	let s="";
	if( dFlag == 1 ) s = y+'-'+m+'-'+d;
	if( dFlag == 2 ) s = y+m+d;
	if( tFlag == 1 ) {
		if( s.length>0 )
			 s = s + ' '+H+':'+M+':'+S
		else s = H+':'+M+':'+S;
	}
	if( wFlag == 1 ) {
		if( s.length>0 )
			 s = s + ' '+days
		else s = days;
	}

	return s;
}

//用于在项目中方便的直接访问项目主框架组件
Vue.prototype.appRoot = { app:null };

/* 用于判断鼠标是否移出指定元素的显示区域, 必须确保调用时该组件是可见的 */
Vue.prototype.onMouseOutHide=function( pOutObj, e, pHideObj, diff ){
	if( !diff ) diff=[0,0,0,0];
	var oRect = pOutObj.getBoundingClientRect();
	var x1 = parseInt(oRect.left);
	var y1 = parseInt(oRect.top);
	var x2 = parseInt(x1 + pOutObj.offsetWidth);
	var y2 = parseInt(y1 + pOutObj.offsetHeight + diff[3]);
	var x3 = e.x;
	var y3 = e.y;

	//console.log( "("+x1, ","+y1, "), ("+x2, ","+y2, "), ("+x3, ","+y3+")" );
	if( (x1==0 && y1==0) || (x2==0 && y2==0) ) return false;

	if( (x1-diff[0])<x3 && x3<(x2+diff[2]) && (y1-diff[1])<y3 && y3<(y2+diff[3]) )   //不能是小于等于
		 return false;  //未移出
	else
	{
		if( pHideObj ) pHideObj.style["display"] = "none";
		return true;   //移出
	}
}
/* diffArr为每个被检测对象在左上右下四个方向需要增加的检测区域偏移量, 用以解决多个部分组合的对象的移出状态判定 */
Vue.prototype.onMouseOutHide2=function( pOutObjArr, e, pHideObj, diffArr ){
	let bl=true;
	for( let i=0; i<pOutObjArr.length; i++ )
	{
		let bl1=this.onMouseOutHide( pOutObjArr[i], e, null, diffArr[i] );
		//console.log( pOutObjArr[i].getAttribute("id"), bl1 );
		if( bl1 == false ) bl = false;
	}
	if( bl && pHideObj ) pHideObj.style["display"] = "none";

	return bl;
}

/* 用于调用子vue对象的onResize方法 */
Vue.prototype.childResize=function( curVue ){
	for( let i=0; i<curVue.$children.length; i++ )
	{
		let curv=curVue.$children[i];
		if( curv.onResize )
		{
			console.log( curv.$options.name+"  resize" );
			curv.onResize();
		}
	}
}

/* 计算图片尺寸缩放, 保证图片缩放之后不超过目标显示区域大小
   w1, h1: 目标显示区域最大尺寸
   w2, h2: 原始图片的尺寸
   返回缩放后能够在目标区域显示的尺寸
*/
Vue.prototype.getZoomSize=function(w1, h1, w2, h2){
	let r1 = w2 / w1;
	let r2 = h2 / h1;
	let w=0;
	let h=0;

	if( r1 > r2 )
	{
		w = w1;
		h = parseInt( w*h2 / w2);
	}
	else
	{
		h = h1;
		w = parseInt( w2*h / h2);
	}
	if( h1 < h ) h = h1;
	if( w1 < w ) w = w1;

	return [w, h];
}

/* CTree的操作图标类型 */
Vue.prototype.OP={
	NO:  0,              //没有添加/删除操作图标
	Add: 1,              //Add图标有效
	Del: 2,              //Del图标有效
	All: 3,              //Add+Del图标有效
	Dis: 9,              //Add+Del图标无效
}

/* 确认提示框类型 */
Vue.prototype.DialogType={
	Suc: 1,              // 成功提示框
	Err: 2,              // 错误提示框
	War: 3,              // 警告提示框
	Tip: 4,              // 信息显示框
}

/* 颜色定义 */
Vue.prototype.CLR={
	Suc: "#24951b",
	Err: "#d2151e",
}

Vue.prototype.splitYMD=function( ymd, ty ){
	if( isNaN(ymd) || ((ymd+"").length != 8) ) return ymd;

	ymd = ymd + "";
	if( ty==1 ) return ymd.substring(0,4)+"-"+ymd.substring(4,6)+"-"+ymd.substring(6,8);

	return ymd;
}

/* 通用的交易执行方法
	pMethod   : 请求方式
	pApi      : 请求的URL地址
	pEndRcall : 请求成功的回调方法 function( res )
	pRunFlag  : 是否显示运行对话框
	pBody     : 需要上送的 body 数据
	pOptions  : http头参数, 暂时未实现
*/
Vue.prototype.doTrade=function( pMethod, pApi, pEndRcall, pRunFlag, pBody, pOptions ){
/*	let opts={ params:{}, jsonp:"handleCallback", headers:{token: this.login.token} };

	if( pRunFlag ) this.appRoot.app.showDlgRun();

	if( pMethod == "POST"   ) this.$http.post(   pApi , pBody, opts).then( pEndRcall, this.onTradeErr );
	if( pMethod == "PUT"    ) this.$http.put(    pApi , pBody, opts).then( pEndRcall, this.onTradeErr );
	if( pMethod == "GET"    ) this.$http.get(    pApi ,        opts).then( pEndRcall, this.onTradeErr );
	if( pMethod == "DELETE" ) this.$http.delete( pApi ,        opts).then( pEndRcall, this.onTradeErr );*/

	if( pRunFlag ) this.appRoot.app.showDlgRun();

	let xhr = new XMLHttpRequest();    //XMLHttpRequest对象
	xhr.open( pMethod, pApi, true);
	xhr.setRequestHeader("token", this.login.token );
	xhr.setRequestHeader("CustId", this.login.custId );
	xhr.setRequestHeader("Content-Type", "application/json" );
	xhr.onload = function( ){
		if( pEndRcall ) pEndRcall( {body: JSON.parse( xhr.responseText )} );   // 外层添加body, 以兼容 this.$http 格式
	};
	xhr.onerror =  function(){
		this.appRoot.app.showDlgTip( 1200, LangText("系统错误"), this.CLR.Err );
	};

	xhr.send( JSON.stringify(pBody) );
}
/* 通用的文件上传方法
	pApi      : 请求的URL地址
	pFormdata : 需要上传的文件数据
*/
Vue.prototype.doUpload=function( pApi, pFileObject, pRunFlag, pFinishRcall, pProgRcall )
{
	if( pRunFlag ) this.appRoot.app.showDlgRun();

	let formData=new FormData();
	formData.append("fileData", pFileObject );

	let xhr = new XMLHttpRequest();    //XMLHttpRequest对象
	xhr.open("post", pApi, true);
	xhr.setRequestHeader("token", this.login.token );
	xhr.setRequestHeader("CustId", this.login.custId );
	//xhr.setRequestHeader("Content-Type", "multipart/form-data" );    // 不能写该数据项
	//xhr.setRequestHeader("Content-Length", pLn );                    // 不能写该数据项
	xhr.onload = function( ){
		if( pFinishRcall )
		{
			if( xhr.responseText == "" )
				 pFinishRcall( {} );
			else pFinishRcall( JSON.parse( xhr.responseText ) );
		}
	};
	xhr.onerror =  function(){
		this.appRoot.app.closeDlgRun();
		this.appRoot.app.showDlgTip( 1200, LangText("上传失败"), this.CLR.Err );
	};
	xhr.upload.onprogress = function( evt ){   //【上传进度调用方法实现】
		if( pProgRcall ) pProgRcall( evt );
	};
	xhr.upload.onloadstart = null;        //上传开始执行方法

	xhr.send( formData );                //开始上传, 发送form数据
}
/* 通用的交易失败处理方法 */
Vue.prototype.onTradeErr=function( res ){
	console.error( "Server error[ "+res+" ]" );
	this.appRoot.app.closeDlgRun();
	this.appRoot.app.showDlgTip( 1200, LangText("系统故障"), this.CLR.Err );
}

Vue.prototype.CoonXml=function( pUrl, pRootTag, pOnReady, pOnError )
{
	var xml={
		new: function(  ){
			var cxml={};

			cxml.xhr=null;
			cxml.root=null;
			cxml.xmlUrl = pUrl;
			cxml.RootTag=pRootTag;
			cxml.onReady=pOnReady;
			cxml.onError=pOnError;

			/********************************************************************************************
			*功能: 初始化
			********************************************************************************************/
			cxml.load=function( )
			{
				console.log( cxml.xmlUrl );
				cxml.xhr = window.XMLHttpRequest ? new window.XMLHttpRequest() : new ActiveXObject("Miscrosoft.XMLHttp");
				if( cxml.xhr == null )
				{
					alert("Error: CoonXml.init, xml is not surport by webbrowser is.");
					return;
				}
				cxml.xhr.open( "GET", cxml.xmlUrl, true );
				cxml.xhr.setRequestHeader("Content-Tpe", "text/xml" );
				cxml.xhr.onreadystatechange = cxml.getXmlContent;
				cxml.xhr.onerror = function(){
					alert("error");
				};
				cxml.xhr.send(null);
			};

			/********************************************************************************************
			*功能: 取得xml的文本
			********************************************************************************************/
			cxml.getXmlContent=function( )
			{
				let content="";
				console.log( "get xml: readyState="+cxml.xhr.readyState +"  "+cxml.xhr.status );
				console.log( cxml.xhr );
				if( cxml.xhr.readyState == 4 && cxml.xhr.status == 200 )
				{
					content = (new DOMParser()).parseFromString( cxml.xhr.response, "text/xml" );

					if( content == null )
					{
						alert("Error: CoonXml.getXmlContent do not get the response data!");
						return;
					}
					console.log( content );

					let Arrs=content.getElementsByTagName( cxml.RootTag );
					if( Arrs ) cxml.root = Arrs[0];

					if( cxml.onReady ) cxml.onReady();
				}
				else
				{
					if( cxml.onError ) cxml.onError( cxml.xhr );
				}
			};

			/********************************************************************************************
			*功能: 取得给定节点列表中的指定节点
			********************************************************************************************/
			cxml.getNode=function( pNodesArr, pNodeTag )
			{
				if( pNodesArr == null ) return null;

				for( let i=0; i<pNodesArr.length; i++ )
				{
					if( pNodesArr[i].nodeType != 1 ) continue;
					if( pNodesArr[i].nodeName == pNodeTag ) return pNodesArr[i];
				}
				return null;
			};

			return cxml;
		}
	};

	return xml.new();
}

export default {
	name: 'FrameApp',
	components:{
		MainMenu, topbar, loginFrm
	},
	data () {
		return {
			savedRoute: "",
			KeyLogin: 100,

			cfmOKFunc: null,                   // dialog对话框回调函数及参数
			tipRCall: null,                    // 提示信息显示结束后的回调函数
			tipRCallParam: null,               // 提示信息显示结束后的回调函数参数
			//keyResize: 1,                      //窗口尺寸变化时, 调整主操作区对象尺寸
			formW: 0,                          //窗口高度
			formH: 0,                          //窗口宽度
			topHeight: 50,                     //顶部的高度

			runPos: {x:0, y:0},                //正在运行对话框的坐标
			tipPos: {x:0, y:0},                //提示信息对话框的坐标
			cfmPos: {x:0, y:0},                //确认信息对话框的坐标
		}
	},
	created: function(){
		this.appRoot.app = this;
	},
	mounted: function(){
		console.log( "FrameApp mounted" );
		this.$refs["idFormTop"].style["height"] = (this.topHeight)+"px";
		this.$refs["idFormLeft"].style["width"] = (this.lftMenu.widthNormal)+"px";
		window.onresize = this.onResize;  this.onResize();

		// 在页面加载时从localStorage中获取当前路由信息并设置路由
		/*this.savedRoute = localStorage.getItem('currentRoute')
		if( this.savedRoute && this.savedRoute!="/" && this.savedRoute!="/FrameBody" ) {
			setTimeout( this.onReloadPath, 200 );
			return;
		}*/

		this.$router.push( "/FrameBody" );
	},
	computed:{

	},
	methods:{
		onReloadPath: function(){
			this.$refs["idFormLogin"].style["display"] = "none";
			this.$refs["idMainL1" ].style["display"] = "block";

			this.$refs["idLoginFrm"].loadLoginInfo();

			this.updateTopbar();
			this.updateLeftMenu();

			this.$router.push( this.savedRoute );
		},
		/* 设置窗口实际应用尺寸 */
		onResize: function(){
			let w=window.innerWidth;
			let h=window.innerHeight;
			this.formW = w;
			this.formH = h;
			//console.log( w , h);
			this.$refs["idFrameApp"].style.width  = (w)+"px";
			this.$refs["idFrameApp"].style.height = (h)+"px";

			this.runPos.x = (w-56)/2;  //(w-251)/2;
			this.runPos.y = 3;         //(h-30);
			this.tipPos.x = (w-400)/2;
			this.tipPos.y = (h-60-200)/2;
			this.cfmPos.x = (w-400)/2;
			this.cfmPos.y = (h-60-200)/2;
			this.$refs["idDlgRun"].style["margin-left"] = (this.runPos.x)+"px";
			this.$refs["idDlgRun"].style["margin-top"]  = (this.runPos.y)+"px";
			this.$refs["idDlgTip"].style["margin-left"] = (this.tipPos.x)+"px";
			this.$refs["idDlgTip"].style["margin-top"]  = "0px"; //(this.tipPos.y)+"px";
			this.$refs["idDlgCfm"].style["margin-left"] = (this.cfmPos.x)+"px";
			this.$refs["idDlgCfm"].style["margin-top"]  = (this.cfmPos.y)+"px";

			this.$refs["idFormLeft"].style["height"] = (h-this.topHeight-5*2)+"px";
			this.$refs["idFormOP"].style["height"]   = (h-this.topHeight-5*2)+"px";

			//this.keyResize++;

			this.childResize( this );
		},
		/* 显示运行对话框 */
		showDlgRun: function(){
			if( this.$refs["idDlgRun"].style["display"] == "block" ) return;

			this.$refs["idDlgMask"].style["display"] = "block";
			this.$refs["idDlgFrm"].style["display"]  = "block";
			//this.$refs["idDlgTip"].style["display"]  = "none";
			this.$refs["idDlgCfm"].style["display"]  = "none";

			if( this.$refs["idDlgRun"].style["display"] == "none" )
			{
				this.$refs["idDlgRun"].style["display"] = "block";
			}
		},
		/* 关闭运行对话框 */
		closeDlgRun: function( res ){
			this.$refs["idDlgMask"].style["display"] = "none";
			this.$refs["idDlgFrm"].style["display"]  = "none";
			this.$refs["idDlgRun"].style["display"]  = "none";
			this.$refs["idDlgTip"].style["display"]  = "none";
			this.$refs["idDlgCfm"].style["display"]  = "none";
		},
		/* 显示确认对话框 */
		showDlgCfm: function( ty, capt, msg, remk, okFunc ){
			this.cfmOKFunc = okFunc;

			this.$refs["idDlgMask"].style["display"] = "block";
			this.$refs["idDlgFrm"].style["display"]  = "block";
			this.$refs["idDlgTip"].style["display"]  = "none";
			this.$refs["idDlgRun"].style["display"]  = "none";

			this.$refs["idCfmCapt"].innerText = capt;
			this.$refs["idCfmRemk"].innerHTML = remk;
			this.$refs["idCfmMsg"].innerText  = msg;
			if( this.DialogType.Err == ty )  // 错误对话框, 1按钮
			{
				this.$refs["idCfmIcon"].style["background"] = "url(../static/images/dialog_err.png)";
				this.$refs["idCfmMsg"].style["color"] = "#ff0000";
				this.$refs["idCfmOK"].style["display"]      = "block";
				this.$refs["idCfmCan"].style["display"]     = "none";
				this.$refs["idCfmOK"].style["margin-left"]  = "165px";
				this.$refs["idCfmCan"].style["margin-right"]= "0px";
			}
			if( this.DialogType.War == ty )  // 警告对话框, 2按钮
			{
				this.$refs["idCfmIcon"].style["background"] = "url(../static/images/dialog_war.png)";
				this.$refs["idCfmMsg"].style["color"] = "#ff0000";
				this.$refs["idCfmOK"].style["display"]      = "block";
				this.$refs["idCfmCan"].style["display"]     = "block";
				this.$refs["idCfmOK"].style["margin-left"]  = "100px";
				this.$refs["idCfmCan"].style["margin-right"]= "100px";
			}
			if( this.DialogType.Tip == ty )  // 信息提示框, 1按钮
			{
				this.$refs["idCfmIcon"].style["background"] = "url(../static/images/dialog_tip.png)";
				this.$refs["idCfmMsg"].style["color"] = "#444444";
				this.$refs["idCfmOK"].style["display"]      = "block";
				this.$refs["idCfmCan"].style["display"]     = "none";
				this.$refs["idCfmOK"].style["margin-left"]  = "165px";
				this.$refs["idCfmCan"].style["margin-right"]= "0px";
			}

			if( this.$refs["idDlgCfm"].style["display"] == "none" )
			{
				this.$refs["idDlgCfm"].style["display"] = "block";
			}
		},
		/* 关闭确认对话框 */
		closeDlgCfm: function( res ){
			this.$refs["idDlgMask"].style["display"] = "none";
			this.$refs["idDlgFrm"].style["display"]  = "none";
			this.$refs["idDlgCfm"].style["display"]  = "none";
			this.$refs["idDlgRun"].style["display"]  = "none";
			this.$refs["idDlgTip"].style["display"]  = "none";
		},
		onCfmOKClick: function() {
			this.closeDlgCfm();
			if( this.cfmOKFunc && this.cfmOKFunc.okFunc ) this.cfmOKFunc.okFunc( this.cfmOKFunc.okParam );
		},
		onCfmCanClick: function( ){
			this.closeDlgCfm();
		},
		/* 显示信息提示框 */
		showDlgTip: function( mis, msg, clr, rcall, rcallparam ){
			this.tipRCall      = rcall;
			this.tipRCallParam = rcallparam;

			if( this.$refs["idDlgRun"].style["display"] == "block" ) return;

			this.$refs["idDlgMask"].style["display"] = "block";
			this.$refs["idDlgFrm"].style["display"]  = "block";
			this.$refs["idDlgRun"].style["display"]  = "none";
			this.$refs["idDlgCfm"].style["display"]  = "none";

			if( this.$refs["idDlgTip"].style["display"] == "none" )
			{
				this.$refs["idDlgTip"].style["display"] = "block";
				this.$refs["idDlgTip"].innerText        = msg;
				this.$refs["idDlgTip"].style["color"]   = clr;
			}
			setTimeout( this.onTipOver, mis );
		},
		onTipOver: function(){
			this.onDlgClick();
			if( this.tipRCall )
			{
				if( this.tipRCallParam )
					 this.tipRCall( this.tipRCallParam );
				else this.tipRCall( );
				this.tipRCall = null;
			}
		},
		onDlgClick: function(){
			if( this.$refs["idDlgTip"].style["display"] == "block" )
			{
				this.$refs["idDlgMask"].style["display"] = "none";
				this.$refs["idDlgFrm"].style["display"]  = "none";
				this.$refs["idDlgTip"].style["display"]  = "none";
				this.$refs["idDlgCfm"].style["display"]  = "none";
				this.$refs["idDlgRun"].style["display"]  = "none";
			}
		},

		/* 左侧菜单显示/隐藏控制 */
		onMenuHideClick: function(){
			this.lftMenu.show = !this.lftMenu.show;
			if( this.lftMenu.show )   //显示
			{
				this.$refs["idMenuHideArr"].setAttribute("class", "MenuHideArr1");
				this.$refs["idFormLeft"].style["width"] = (this.lftMenu.widthNormal)+"px";
			}
			else
			{
				this.$refs["idMenuHideArr"].setAttribute("class", "MenuHideArr2");
				this.$refs["idFormLeft"].style["width"] = (this.lftMenu.widthHide)+"px";
			}
			this.onResize();
		},

		loadRouter: function( pPath, pParam ){
			this.$router.push( {path:pPath, query:pParam} );
			//return this.$router.currentRoute;
		},
		updateLeftMenu: function(){
			this.$refs["idMainMenu"].loadMenu();
		},
		updateTopbar: function(){
			this.$refs["idTopbar"].updateInfo();
		},
		/* 全窗口模式 */
		fullBody: function( flag, clr ){
			if( flag )
			{
				this.$refs["idFormTop"].style["display"] = "none";
				this.$refs["idFormLeft"].style["display"] = "none";
				this.$refs["idMenuHidePan"].style["display"] = "none";

				this.$refs["idHSplit1"].style["background"] = clr;
				this.$refs["idHSplit2"].style["background"] = clr;

				this.$refs["idRSplit1"].style["background"] = clr;
				this.$refs["idRSplit2"].style["background"] = clr;
				this.$refs["idRSplit3"].style["background"] = clr;

			}
			else
			{
				this.$refs["idFormTop"].style["display"] = "block";
				this.$refs["idFormLeft"].style["display"] = "block";
				this.$refs["idMenuHidePan"].style["display"] = "block";

				this.$refs["idHSplit1"].style["background"] = "var(--clrBG1)";
				this.$refs["idHSplit2"].style["background"] = "var(--clrBG1)";

				this.$refs["idRSplit1"].style["background"] = "var(--clrBG1)";
				this.$refs["idRSplit2"].style["background"] = "var(--clrBG1)";
				this.$refs["idRSplit3"].style["background"] = "var(--clrBG1)";
			}
		},
	}
}

</script>

<style scoped>

#idFrameApp{ display: -webkit-flex; display:flex; width:100%; height:100%; }

#idFormLogin{ border:0px solid red; width:100%; height:100%; display:block; }

/* 主界面第一层, 承载登录后的所有主界面组件 */
#idMainL1{  border:0px solid red; width:100%; height:100%; display:none;  }
/* 主界面第二层, 内部定义 上/下 */
#idMainL2{  border:0px solid blue; display: -webkit-flex; display:flex; flex-direction: column; width:100%; height:100%; }
/* 主界面第三层, 内部定义 左/右 */
#idMainL3{  border:0px solid blue; display: -webkit-flex; display:flex; flex-direction: row; width:100%; height:100%; }

/* 正在运行对话框 */
#idDlgMask{position:absolute; z-index:990; width:100%; height:100%; border:0px solid red; background:#ffffff; filter:alpha(Opacity=30); -moz-opacity:0.3; opacity: 0.3;}
#idDlgRun{float:left; width:50px;  height:50px; background:url(../static/images/run4.gif); background-size:100% 100%;}
#idDlgTip{float:left; width:400px; height:55px; line-height:60px; text-align:center; letter-spacing:0px; font-size:20px; background:#dddddd; }
#idDlgCfm{float:left; width:400px; height:230px; z-index:1000; border:0px solid #bbbbbb; box-shadow:0 0 3px rgba(0, 0, 0, .8); background:#ffffff; border-radius:7px; }

/* 左侧菜单区显示/隐藏控制 */
.MenuHideArr1{       background:url(../static/images/menu_expand_arrow1.png); background-size:100% 100%; }
.MenuHideArr1:hover{ background:url(../static/images/menu_expand_arrow1_a.png); background-size:100% 100%; }
.MenuHideArr2{       background:url(../static/images/menu_expand_arrow2.png); background-size:100% 100%; }
.MenuHideArr2:hover{ background:url(../static/images/menu_expand_arrow2_a.png); background-size:100% 100%; }

</style>

<style>


</style>



// WEBPACK FOOTER //
// FrameApp.vue?4188cade